import { makeAutoObservable } from 'mobx';
import { IEvent, IRootStoreExporter, IActivityRecord } from '../../interfaces';

export class ScoreEventStore implements IRootStoreExporter {
    public activeEvent: IEvent = null;
    public snapshot: IActivityRecord = null;
    public setActiveEvent(event: IEvent) {
        this.activeEvent = event;
    }

    constructor() {
        makeAutoObservable(this);
    }
    public exportKeys(): string[] {
        return [];
    }
}

export default new ScoreEventStore();
